
























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { FiltersModel } from '../../models/filters/filters.model';
import DateFilter from './DateFilter/DateFilter.vue';
import NumberFilter from './NumberFilter/NumberFilter.vue';
import {
  FilterInput,
  FilterConditions,
  TransformFiltersToJson
} from '@/shared/services/filter/filter.service';
import { DateType } from '../../models/filters/date-filter.model';
import { NumberType } from '../../models/filters/number-filter.model';
import moment from 'moment';
import {
  BS_DATEPICKER_FORMAT,
  convertDateArrayFormatFieldToAPIFormat,
  DATE_API_FORMAT
} from '@/utils/date.util';
import { createDivisionFilter } from '@/shared/services/division/division.helper';

import { DispatchModule, DivisionModule } from '@/store/index';
import { DispatchType } from '../../models/dispatch.model';

import SelectionFilter from '@/shared/components/form/SelectionFilter.vue';

@Component({
  components: { DateFilter, NumberFilter, SelectionFilter }
})
export default class VanFilters extends Vue {
  @Watch('$route', { immediate: true, deep: true })
  onRouterChange() {
    this.generateFilters();
    this.search();
  }
  @Watch('division')
  onDivisionChange() {
    this.search();
  }

  dispatchModule = DispatchModule;
  divisionModule = DivisionModule;
  form: any;
  excelData: any;

  selectionTypes = {
    list: [
      { value: NumberType.ContainerNumber, text: 'Container#' },
      { value: NumberType.OrderNumber, text: 'WO#' },
      { value: NumberType.ReferenceNumber, text: 'REF#' },
      { value: NumberType.PONumber, text: 'PO#' },
      { value: NumberType.MasterBillOfLading, text: 'MBL#' },
      { value: NumberType.BillTo, text: 'Bill To' },
      { value: NumberType.PulloutLocation, text: 'P/U' },
      { value: NumberType.DeliveryLocation, text: 'Delivery' },
      { value: NumberType.ReturnLocation, text: 'Return' },
      { value: NumberType.Driver, text: 'DRV ID' }
    ],
    autocompleteList: [
      NumberType.BillTo,
      NumberType.DeliveryLocation,
      NumberType.ReturnLocation
    ]
  };

  fromFilter = null;

  toFilter = null;

  typeFilter = null;

  constructor() {
    super();
    this.generateFilters();
    this.form = new FiltersModel();
  }

  get division() {
    return this.divisionModule.division;
  }

  generateFilters() {
    this.fromFilter = new FilterInput({
      condition: FilterConditions.GreaterOrEqual,
      search: moment().subtract(12, 'days').format(BS_DATEPICKER_FORMAT),
      field: DateType.CreatedDate
    });

    this.toFilter = new FilterInput({
      condition: FilterConditions.LessThenOrEqual,
      search: moment().format(BS_DATEPICKER_FORMAT),
      field: DateType.CreatedDate
    });

    this.typeFilter = new FilterInput({
      condition: FilterConditions.Include,
      search: null,
      field: NumberType.ContainerNumber
    });
  }

  numberChanged(items) {
    this.typeFilter.search = items.value;
    this.typeFilter.field = items.field;
    console.log(this.$route);
  }

  search() {
    this.fromFilter.search = convertDateArrayFormatFieldToAPIFormat(
      this.fromFilter.search,
      [BS_DATEPICKER_FORMAT, DATE_API_FORMAT]
    );

    this.toFilter.search = moment(this.toFilter.search, [
      BS_DATEPICKER_FORMAT,
      DATE_API_FORMAT
    ])
      .endOf('day')
      .format(DATE_API_FORMAT);

    DispatchModule.setFilters(this.getFilters());

    DispatchModule.search({
      dispatchType: DispatchType[this.$route.name.substr(0, 3).toUpperCase()],
      category: this.$route.params.type
    });
  }

  async excel() {
    DispatchModule.setFilters(this.getFilters());

    await DispatchModule.excel({
      dispatchType: DispatchType[this.$route.name.substr(0, 3).toUpperCase()],
      category: this.$route.params.type
    });

    if (DispatchModule.excelData) {
      window.open(DispatchModule.excelData.url);
    }
  }

  resetFilters() {
    (this.$refs as any).dateFilter.resetFilter();
    (this.$refs as any).selectionFilter.resetFilter();
    this.generateFilters();
    DispatchModule.setFilters(this.getFilters());
  }

  private getFilters(): string {
    return TransformFiltersToJson([
      this.toFilter,
      this.fromFilter,
      this.typeFilter,
      createDivisionFilter()
    ]);
  }
}
